import clientAxiosInstance from "./clientAxiosInstance";

/**
 * Fetches the list of documents for a specific household (client portal).
 * @param {string} householdId 
 * @param {string} clientToken 
 * @returns {Promise<Array>} List of documents
 */
export const fetchClientDocuments = async (householdId, clientToken) => {
  if (!householdId) throw new Error("Household ID is required");
  if (!clientToken) throw new Error("Client token is required");

  try {
    const response = await clientAxiosInstance.get(
      `/client/household/${householdId}/documents`,
      {
        headers: {
          Authorization: `Bearer ${clientToken}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching client documents:", error);
    throw error.response?.data?.detail || "Failed to fetch documents";
  }
};

/**
 * Fetches a presigned URL for viewing a specific document (client portal).
 * @param {string} householdId 
 * @param {string} documentId 
 * @param {string} clientToken 
 * @returns {Promise<string>} Presigned URL
 */
export const fetchClientDocumentUrl = async (householdId, documentId, clientToken) => {
  if (!householdId) throw new Error("Household ID is required");
  if (!documentId) throw new Error("Document ID is required");
  if (!clientToken) throw new Error("Client token is required");

  try {
    const response = await clientAxiosInstance.get(
      `/client/household/${householdId}/documents/${documentId}/presigned-url`,
      {
        headers: {
          Authorization: `Bearer ${clientToken}`
        }
      }
    );
    return response.data.presigned_url;
  } catch (error) {
    console.error("Error fetching client document URL:", error);
    throw error.response?.data?.detail || "Failed to fetch document URL";
  }
};
